import { LOGIN, LOGOUT } from './actions';

const accountReducer = (state, action) => {
  switch (action.type) {
    case 'INITIALIZE':
      return {
        ...state,
        isInitialized: true
      };

    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user
      };

    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null
      };

    default:
      return state;
  }
};

export default accountReducer;
